import { useCanEdit, useCanEditArchived } from '../../lib/usersPermissions'
import classes from './Button.module.css'
import BodySimpleModal from './modal/BodySimpleModal'


const Button = ({children, type, btnStyle, click, color, width, isLoading, isDisabled, loaderType, title, messages, square, bypassisCaseArchived, noHover}) => {
    // let masterDisable = useCanEdit(bypassisCaseArchived)
    let editArchivedDisabled = useCanEditArchived(bypassisCaseArchived)

    return <button className={`${classes.btn} ${classes[btnStyle]} ${classes[color]} ${classes[width]} ${square ? classes.btn_square : ''} ${noHover ? classes.no_hover : ''}`} type={type} onClick={click} disabled={isLoading || isDisabled || editArchivedDisabled} title={title}>
        {!isLoading && children}
        {isLoading && <span className={`loader ${loaderType ? loaderType : ''}`}></span>}
        <BodySimpleModal isDisabled={isDisabled || editArchivedDisabled} messages={messages}/>
    </button>
}

export default Button